import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios"

export const useAddAttachment = () => {

    const axios = useAxios();
    const {t} = useTranslation();

    const addAttachment = async (file: any) => {
        const formData = new FormData();
        formData.append('file', file);
        try {
            const response = await axios.post('/api/attachments', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            throw new Error(t("errors.attachmentAdd"));
        }
    }

    return {
        addAttachment
    }
}